"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HWProvider = void 0;
const hw_transport_u2f_1 = __importDefault(require("@ledgerhq/hw-transport-u2f"));
const hw_transport_webusb_1 = __importDefault(require("@ledgerhq/hw-transport-webusb"));
// @ts-ignore
const hw_app_elrond_1 = __importDefault(require("@elrondnetwork/hw-app-elrond"));
const platform_1 = __importDefault(require("platform"));
const address_1 = require("../address");
const signature_1 = require("../signature");
const versioning_1 = require("../versioning");
const constants_1 = require("./constants");
const networkParams_1 = require("../networkParams");
class HWProvider {
    constructor(httpProvider, addressIndex = 0) {
        this.addressIndex = 0;
        this.provider = httpProvider;
        this.addressIndex = addressIndex;
    }
    /**
     * Creates transport and initialises ledger app.
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let webUSBSupported = yield hw_transport_webusb_1.default.isSupported();
                webUSBSupported =
                    webUSBSupported && !!platform_1.default.os && platform_1.default.os.family !== "Windows" && platform_1.default.name !== "Opera";
                const transport = webUSBSupported ? yield hw_transport_webusb_1.default.create() : yield hw_transport_u2f_1.default.create();
                this.hwApp = new hw_app_elrond_1.default(transport);
                return true;
            }
            catch (error) {
                return false;
            }
        });
    }
    /**
     * Returns true if init() was previously called successfully
     */
    isInitialized() {
        return !!this.hwApp;
    }
    /**
     * Mocked function, returns isInitialized as an async function
     */
    isConnected() {
        return new Promise((resolve, _) => resolve(this.isInitialized()));
    }
    /**
     * Mocks a login request by returning the ledger selected address
     */
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hwApp) {
                throw new Error("HWApp not initialised, call init() first");
            }
            const { address } = yield this.hwApp.getAddress(0, this.addressIndex, true);
            return address;
        });
    }
    getAccounts(startIndex = 0, length = 10) {
        var e_1, _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hwApp) {
                throw new Error("HWApp not initialised, call init() first");
            }
            const addresses = [];
            const indexesArray = this.generateArray(startIndex, length);
            try {
                for (var indexesArray_1 = __asyncValues(indexesArray), indexesArray_1_1; indexesArray_1_1 = yield indexesArray_1.next(), !indexesArray_1_1.done;) {
                    const index = indexesArray_1_1.value;
                    const { address } = yield this.hwApp.getAddress(0, index);
                    addresses.push(address);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (indexesArray_1_1 && !indexesArray_1_1.done && (_a = indexesArray_1.return)) yield _a.call(indexesArray_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return addresses;
        });
    }
    generateArray(startIndex = 0, length = 10) {
        var data = [];
        for (var i = length * startIndex; i < length * startIndex + length; i++) {
            data.push(i);
        }
        return data;
    }
    /**
     * Mocks a logout request by returning true
     */
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hwApp) {
                throw new Error("HWApp not initialised, call init() first");
            }
            return true;
        });
    }
    /**
     * Fetches current selected ledger address
     */
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getCurrentAddress();
        });
    }
    /**
     * Signs and sends a transaction. Returns the transaction hash
     * @param transaction
     */
    sendTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hwApp) {
                throw new Error("HWApp not initialised, call init() first");
            }
            const address = yield this.getCurrentAddress();
            transaction.sender = new address_1.Address(address);
            let signUsingHash = yield this.shouldSignUsingHash();
            if (signUsingHash) {
                transaction.options = networkParams_1.TransactionOptions.withTxHashSignOptions();
                transaction.version = networkParams_1.TransactionVersion.withTxHashSignVersion();
            }
            const sig = yield this.hwApp.signTransaction(transaction.serializeForSigning(new address_1.Address(address)), signUsingHash);
            transaction.signature = new signature_1.Signature(sig);
            yield transaction.send(this.provider);
            return transaction;
        });
    }
    shouldSignUsingHash() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hwApp) {
                throw new Error("HWApp not initialised, call init() first");
            }
            const config = yield this.hwApp.getAppConfiguration();
            let diff = versioning_1.compareVersions(config.version, constants_1.LEDGER_TX_HASH_SIGN_MIN_VERSION);
            return diff >= 0;
        });
    }
    getCurrentAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hwApp) {
                throw new Error("HWApp not initialised, call init() first");
            }
            const { address } = yield this.hwApp.getAddress(0, this.addressIndex);
            return address;
        });
    }
}
exports.HWProvider = HWProvider;
//# sourceMappingURL=hwProvider.js.map